// extracted by mini-css-extract-plugin
module.exports = {"productGroupBreadcrumb":"style_productGroupBreadcrumb__08lsn"};